import * as React from "react";
import { selectStandardStageResources } from "../../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../../constants/IdResource";
import { IdStyles } from "../../../../less/IdStyles";
import { IdInventoryResourceRequirementPosition } from "../../../generic/inventory-resource-requirement/IdInventoryResourceRequirementPosition";
import { InventoryResourceRequirement } from "../../../generic/inventory-resource-requirement/InventoryResourceRequirement";
import { WorkersRequirement } from "../../../generic/workers-requirement/WorkersRequirement";
export var BuildingUpgradeRequirements = function (_a) {
    var nextStage = _a.nextStage, currentStage = _a.currentStage;
    var resources = selectStandardStageResources(nextStage);
    resources = resources && resources.filter(function (_a) {
        var id = _a.id;
        return id !== IdResource.Money;
    });
    var totalWorkers = nextStage.workers - currentStage.workers;
    var getOtherStandardRequirements = function () {
        return (resources || []).map(function (resource) {
            var amount = resource.amount, id = resource.id;
            return (React.createElement("div", { className: "building-upgrade__requirement-item", key: resource.id },
                React.createElement(InventoryResourceRequirement, { required: amount, resourceId: id, position: IdInventoryResourceRequirementPosition.Horizontal, iconStyleId: IdStyles.IconMedium })));
        });
    };
    var workersRequirements = totalWorkers < 0 && React.createElement(WorkersRequirement, { total: totalWorkers });
    var otherStandardRequirements = getOtherStandardRequirements();
    var hasRequirements = workersRequirements || (otherStandardRequirements && otherStandardRequirements.length);
    var requirementClassName = hasRequirements
        ? "building-upgrade__requirement-wrapper--with-requirements"
        : "building-upgrade__requirement-wrapper--no-requirements";
    return (React.createElement("div", { className: "building-upgrade__requirement-wrapper " + requirementClassName },
        React.createElement("hr", { className: "dialog-divider" }),
        hasRequirements ? (React.createElement("div", { className: IdStyles.BuildingUpgradeRequirementWrapper + " building-upgrade__requirement" },
            workersRequirements && workersRequirements,
            otherStandardRequirements && otherStandardRequirements)) : (undefined),
        React.createElement("hr", { className: "dialog-divider" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgradeRequirements.tsx
// module id = 2863
// module chunks = 3